module.exports = __webpack_public_path__ + "img/exclamation-mark-green.b0c563f.svg";